import { Component, Input } from '@angular/core';

@Component({
  selector: 'via-scorecard',
  templateUrl: './scorecard.component.html',
  styleUrls: ['./scorecard.component.scss']
})
export class ScorecardComponent {

  @Input() public title = '';
  @Input() public value = '';
  @Input() public iconClass = '';

}
